<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main">
      <van-pull-refresh :pulling-text="$t('reservation.refresh')"
			:loosing-text="$t('reservation.refresh')"
			:loading-text="$t('reservation.refresh')"
			:success-text="$t('reservation.refresh')" v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0"  :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.lottery.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <div class="lottery_meta">
              <span class="period-number">{{v.expect}}</span>
              <span class="type-label">{{v.type_ko}}</span>
            </div>
          </div>
          <div class="recent" v-if="v.status === 1">
            <div class="kuaisan-ball left">
              <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/123.gif' : 'img/lottery/shaizi/' + v.opencode[0] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/123.gif' : 'img/lottery/shaizi/' + v.opencode[1] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
              <van-image class="res-img" :src=" v.status === 0 ? 'img/lottery/123.gif' : 'img/lottery/shaizi/' + v.opencode[2] + '.png' " >
                <template v-slot:loading>
                  <van-loading type="spinner"/>
                </template>
              </van-image>
<!--              <span class="res-des middle">{{v.status === 0 ? 0 : v.opencode[0] + v.opencode[1] + v.opencode[2]}}</span>
              <span class="res-des middle">{{v.status === 0 ? 0 : (v.opencode[0] + v.opencode[1] + v.opencode[2]) >= 11 && (v.opencode[0] + v.opencode[1] + v.opencode[2]) &lt;= 18 ? $t("reservation.big") : $t("reservation.small")}}</span>
              <span class="res-des middle">{{v.status === 0 ? 0 : (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0 ? $t("reservation.double") : $t("reservation.single")}}</span>-->

              <span class="res-des middle">{{(v.opencode[0] + v.opencode[1] + v.opencode[2]) >= 11 && (v.opencode[0] + v.opencode[1] + v.opencode[2]) &lt;= 18 ? $t("reservation.big") : $t("reservation.small")}}</span>
              <span class="res-des middle">{{(v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0 ? $t("reservation.double") : $t("reservation.single")}}</span>

            </div>
          </div>
          <div class="topInfo">
            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
            <span v-else>{{v.status_text}}</span>
            <span>{{getMoneyLabel(v)}}：{{v.money}}</span>
          </div>
       <!--   <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
          <!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[],
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      this.getUserGameList(true);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = this.groupGameRecords(res.data);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      }).finally(() => {
        this.isLoading = false;
      })
    },
    getGroupKey(item){
      return [item.lid, item.expect, item.create_time].join('_');
    },
    formatMoney(value){
      const amount = Number(value || 0);
      return amount.toFixed(2);
    },
    getMoneyLabel(item){
      return item && item.group_count > 1 ? this.$t("reservation.total") : this.$t("reservation.money");
    },
    groupGameRecords(items){
      const groups = {};

      (items || []).forEach(item => {
        const groupKey = this.getGroupKey(item);
        const typeName = item.type_ko || item.type || '';
        const money = Number(item.money || 0);

        if (!groups[groupKey]) {
          groups[groupKey] = {
            ...item,
            group_count: 0,
            total_money: 0,
            type_names: [],
          };
        }

        const group = groups[groupKey];
        group.id = Math.max(Number(group.id || 0), Number(item.id || 0));
        group.group_count += 1;
        group.total_money += money;

        if (typeName && group.type_names.indexOf(typeName) === -1) {
          group.type_names.push(typeName);
        }

        if (group.status !== 0 && item.status === 0) {
          group.status = 0;
          group.status_text = item.status_text;
          group.update_time = item.update_time;
        }

        if (!group.opencode && item.opencode) {
          group.opencode = item.opencode;
        }
      });

      return Object.values(groups)
        .map(item => ({
          ...item,
          type_ko: item.type_names.join(' / '),
          money: this.formatMoney(item.total_money),
        }))
        .sort((a, b) => Number(b.id || 0) - Number(a.id || 0));
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{
  float: right;
}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list .lottery_meta{
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  margin-left: 25px;
}
.item_list  .period-number{
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}
.item_list .type-label{
  line-height: 1.4;
  font-size: 28px;
  font-weight: 600;
  color: #000;
  word-break: break-word;
}
.item_list .lottery_info{
  display: flex;
  align-items: flex-start;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  width: 25%;
  font-size: 35px;
}
</style>
